import { Route } from "react-router-dom";
import DashboardNetworkView from "src/views/authenticated/network/NetworkView";
import DashboardNetworkInviteView from "src/views/authenticated/network/Invite/NetworkInviteView";
import ProtectedRoute from "src/routes/middlewares/ProtectedRoute";

const NetworkRoutes = [
	<Route
		element={
			<ProtectedRoute>
				<DashboardNetworkView />
			</ProtectedRoute>
		}
		path="/network"
		key="/network"
	/>,
	<Route
		element={
			<ProtectedRoute type="student">
				<DashboardNetworkInviteView />
			</ProtectedRoute>
		}
		path="/network/:id/invite"
		key="/network/:id/invite"
	/>,
];

export default NetworkRoutes;
